export interface ISlaWidget {
  subHeading: string | null;
  activeSla: DisplayMode;
  contentPolicyLink: string | null;
  generalItems: Sla[];
  christmasItems: Sla[];
  description: string | null;
}

export type Sla = {
  name: string;
  value: string;
  christmasDeadline?: Date;
  newYearDeadline?: Date;
};

export enum SlaWidgetFields {
  subHeading = 'subHeading',
  activeSla = 'activeSla',
  contentPolicyLink = 'contentPolicyLink',
  generalItems = 'generalItems',
  christmasItems = 'christmasItems',
  description = 'description'
}

export interface ISlaWidgetForm {
  [SlaWidgetFields.subHeading]: string | null;
  [SlaWidgetFields.activeSla]: DisplayMode;
  [SlaWidgetFields.contentPolicyLink]: string | null;
  [SlaWidgetFields.generalItems]: Sla[];
  [SlaWidgetFields.christmasItems]: Sla[];
  [SlaWidgetFields.description]: string | null;
}

export enum DisplayMode {
  General = 'General',
  Christmas = 'Christmas'
}